"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_PATH_EDS = void 0;
const config_1 = require("config");
exports.BASE_PATH_EDS = config_1.PATH.CREDIT_PORTAL + config_1.PATH.CREDIT_APPLICATION + config_1.PATH.EDS.BASE;
